import { post } from '@/api/http'
import { jsFn } from '@/utils/js-fn'
import profile from '@/utils/profile'
// let hostname = window.location.hostname
var serverLocation = jsFn.isCN() ? 'cn' : 'global'

// if(hostname.indexOf('-rc') > 0) {
//     serverLocation += 'rc'
// }

// if(hostname.indexOf('localhost') === 0) {
//     serverLocation = 'globalrc'
// }

var apiUrl = profile.ies5Api[serverLocation]
export default {
    /** 申請加入學校 */
    applySchool: function(schoolCode) {
        return new Promise((resolve, reject) => {
            let data = {
                grant_type: 'request',
                school_code: schoolCode
            }

            post(apiUrl + '/hita/school-join-request', data).then(() => {
                resolve(true)
            }, err => {
                reject(err)
            })
        })
    }
}
